import {_, classNames, React, Fragment} from '@api'
import {CatalogItemSidebarDetailsStore, useCatalogItemSidebarDetailsStore} from '@modules'
import {Spinner} from '@blueprintjs/core'
import {computed} from 'mobx'
import {ImageWrapperDefinition} from '@api/graphql'

import {Backdrop, Grid, Typography, Tooltip} from '@material-ui/core'
import SwipeableViews from 'react-swipeable-views'
import {PrimaryIconButton, SecondaryButton, PrimaryButton} from 'centric-ui-components'
import {map} from 'lodash'
import {KeyboardArrowLeft, KeyboardArrowRight, Delete, GetApp, Close} from '@material-ui/icons'
import {nav} from '@stores'
import * as css from './Slider.css'
import {Loading, MyImage} from '../../components'
import {Tooltip2} from '@api'

interface MyProps {
  localImages: Array<ImageWrapperDefinition>
  onClose: (e) => void
  onDelete?: (e, opration?: string) => void,
  onAddImage: (e) => void
  showHex?: boolean,
  largeImageURL?: string,
  downloadImageURL?: string,
  multiple: boolean
  accept: string
  onDownload: (e, image) => void
  onClickSetDefault: (e, image) => void
  activeImageId?: string
  updateActiveStepOnParent?: (e) => void,
  hex?: string,
  isPLMSpec?: boolean,
  loading?: boolean,
  disableUpload?: boolean,
  detailsStore?: CatalogItemSidebarDetailsStore
  className?: string
}

export class Slider extends React.Component <MyProps> {
  inputRef = React.createRef<HTMLInputElement>()
  state = {
    activeStep: 0,
    activeImageId: null
  }

  static defaultProps = {
    onClickSetDefault: () => {},
    onClose: () => {},
    onDelete: () => {},
    onDownload: () => {},
    onAddImage: () => {},
    localImages: [],
    multiple: true,
    accept: '.jpg, .jpeg, .png',
    isPLMSpec: false,
    loading: false,
    disableUpload: false
  }

  static getDerivedStateFromProps = (nextProps, state) => {
    if (nextProps.activeImageId) {
      let imageIndex = _.findIndex(nextProps.localImages, (image: any) => image.exId === nextProps.activeImageId)
      return {
        activeImageId: nextProps.activeImageId,
        activeStep: imageIndex > -1 ? imageIndex : state.activeStep
      }
    }

    return null
  }

  handleBack = (e) => {
    e.stopPropagation()
    this.setState(prevState => {
      let activeStep = prevState['activeStep']
      activeStep--
      if (this.props.updateActiveStepOnParent) {
        this.props.updateActiveStepOnParent(activeStep)
      }
      return {
        activeStep
      }
    })
  }

  handleNext = (e) => {
    e.stopPropagation()
    this.setState(prevState => {
      let activeStep = prevState['activeStep']
      activeStep++
      if (activeStep >= this.props.localImages.length) {
        activeStep = 0
      }

      if (this.props.updateActiveStepOnParent) {
        this.props.updateActiveStepOnParent(activeStep)
      }
      return {
        activeStep
      }
    })
  }

  handleStepChange = activeStep => {
    this.setState({activeStep})
  }

  onAdd = (e) => {
    e.stopPropagation()
    const {inputRef: {current}} = this
    current && current.click()
  }

  onChanceStep = activeStep => {
    this.setState({activeStep})
  }

  @computed get disableDeleteImage() {
    const {detailsStore: {imageSources, stores}, localImages} = this.props,
      imageSource = imageSources.find(src => src.id === stores.catalog?.workspaceConfig?._id || src.index === stores.catalog.index)?.field ?? ''
    return localImages[this.state.activeStep]?.source == imageSource ? false : true
  }

  render() {
    const {
      localImages,
      onClose,
      onAddImage,
      onClickSetDefault,
      onDownload,
      hex,
      isPLMSpec,
      loading,
      disableUpload, className,
      detailsStore: {stores, isOffline, manageImage}
    } = this.props
    const {
      activeStep
    } = this.state
    const {
      strings, vlp: {isVLPView}, sidebar,
      catalog: {
        canAddImage, features: {actionButtons},
        workspaceConfig: {itemName}
      }
    } = stores

    return (
      <>
        {localImages.length > 1 &&
		 <div className={css.icon} data-icon='left'>
			 <PrimaryIconButton
				 icon={<KeyboardArrowLeft/>}
				 disabled={activeStep === 0}
				 className={classNames(css.navButton)}
				 onClick={this.handleBack}
			 />
		 </div>}
        <div className={classNames(css.root, className)} onClick={(event: any) => {
          event.preventDefault()
          event.stopPropagation()
          onClose(event)
        }}>
          <Backdrop open classes={{root: css.backdrop}}/>
          <div className={css.top}>
            {(!disableUpload) && actionButtons && <Fragment>
              {!isPLMSpec && canAddImage &&
			   <SecondaryButton onClick={this.onAdd}>
				   <Typography variant={'h5'}>{strings.addImage}</Typography>
				   <input type='file' accept={'.jpg, .jpeg, .png'} multiple={true} ref={this.inputRef} style={{display: 'none'}} onChange={onAddImage}/>
			   </SecondaryButton>}
				<div className={css.verticalLine}/>
              {itemName != 'MPV' && localImages[activeStep] && !localImages[activeStep].hex && !isPLMSpec &&
			   <Tooltip2 content={strings.delete}>
				   <PrimaryIconButton
					   disabled={!localImages[activeStep] || this.disableDeleteImage || (!isOffline && _.isNull(localImages[activeStep]?.exId)) || (!isOffline && _.isUndefined(localImages[activeStep]?.exId))}
					   icon={<Delete/>}
					   onClick={(e) => {
                         e.stopPropagation()
                         manageImage(isOffline ? activeStep : localImages[activeStep]?.exId, 'delete', localImages[activeStep], () => activeStep && this.onChanceStep(activeStep - 1))
                       }}
				   />
			   </Tooltip2>}
			</Fragment>}
            {localImages[activeStep] && !localImages[activeStep].hex && (!isPLMSpec || isVLPView) &&
			 <Tooltip2 content={strings.downloadImage}>
				 <PrimaryIconButton
					 icon={<GetApp/>}
					 onClick={(e) => {
                       e.stopPropagation()
                       onDownload(e, localImages[activeStep])
                     }}
				 />
			 </Tooltip2>}
            <Tooltip2 content={strings.close}>
              <PrimaryIconButton
                icon={<Close/>}
                onClick={(e) => {
                  e.stopPropagation()
                  onClose(e)
                }}
              />
            </Tooltip2>
          </div>
          <div className={css.container}>
            {loading ? <div className={css.images}><Loading/></div> :
             <Fragment>
               <SwipeableViews
                 index={activeStep}
                 onChangeIndex={this.handleStepChange}
                 enableMouseEvents
               >
                 {map(localImages, (img, index) => {
                   const key = `${img?.id ?? img?.exId}.${index}`

                   return (img.hex && img.showHex)
                          ? (
                            <div key={key}
                                 className={css.hexImage}
                                 style={{backgroundColor: img.hex}}
                            />)
                          : (
                            <MyImage key={key}
                                     imageUrl={img.largeImageURL}
                                     imageId={img.exId}
                                     className={css.images}
                                     customLinkOff largeImage/>
                          )
                 })}
               </SwipeableViews>
             </Fragment>
            }
          </div>
          {sidebar?.right?.details?.isDirty && <SaveChangesButtons/>}
          <Grid container spacing={10} classes={{'spacing-xs-10': css.gridSpacing}}>
            <Grid item xs={3}>
              {
                activeStep === 0 ? <div className={css.defaultImage}>Default Image</div> :
                (!hex && !isPLMSpec && !isVLPView) ? <SecondaryButton onClick={(e) => {
                  e.stopPropagation()
                  onClickSetDefault(e, localImages[activeStep])
                }} classes={{root: css.secondary}}>Set As Default</SecondaryButton> : null}
            </Grid>
            <Grid item xs={6} classes={{item: css.item}}>
              {`${activeStep + 1} of ${localImages.length}`}
            </Grid>
            <Grid item xs={'auto'}>
            </Grid>
          </Grid>
        </div>
        {localImages.length > 1 && <div className={css.icon} data-icon='right'>
			<PrimaryIconButton
				icon={<KeyboardArrowRight/>}
				//disabled={activeStep + 1  >= localImages.length}
				className={classNames(css.navButton)}
				onClick={this.handleNext}
			/>
		</div>}
      </>
    )
  }
}

const SaveChangesButtons = () => {
  const {strings, isApplyingMutations, isDirty, mutationSaveCatalogItemDetails, cancelMutations, isOffline, saveOfflineChanges} = useCatalogItemSidebarDetailsStore()

  if (!isDirty) return null
  return (
    <div className={css.saveChangesBar}>
      <SecondaryButton onClick={(e) => {
        e.stopPropagation()
        cancelMutations()
      }} disabled={isApplyingMutations}>{_.capitalize(strings.cancel)}</SecondaryButton>
      <PrimaryButton onClick={(e) => {
        e.stopPropagation()
        isOffline ? saveOfflineChanges() : mutationSaveCatalogItemDetails()
      }} disabled={isApplyingMutations}>{isApplyingMutations ? <Spinner size={20}/> : _.capitalize(strings.save)}</PrimaryButton>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/Slider/Slider.tsx